/* yancha welcome game: flip cards, three matches unlock the offer. the deck is fixed, so everyone wins. */
(function(){
  const KEY = 'yGame', NATIVE = 'yGameNative', DAY = 864e5;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const html = document.documentElement;
  const store = {
    get(){ try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch(e){ return null; } },
    set(s){ try { localStorage.setItem(KEY, JSON.stringify({s, t: Date.now()})); } catch(e){} }
  };
  const flag = {
    get(){ try { return sessionStorage.getItem(NATIVE) === '1'; } catch(e){ return false; } },
    set(on){ try { on ? sessionStorage.setItem(NATIVE, '1') : sessionStorage.removeItem(NATIVE); } catch(e){} }
  };

  function init(){
    const g = document.getElementById('game');
    if (!g || g.dataset.ready) return;
    g.dataset.ready = '1';
    const d = g.dataset, code = d.code || '';
    const preview = d.preview === 'true';
    const box = g.querySelector('.game-box');
    const steps = [...g.querySelectorAll('.game-step')];
    const cards = [...g.querySelectorAll('.gcard')];
    const dots = [...g.querySelectorAll('.gdots i')];
    const status = document.getElementById('gameStatus');
    const form = document.getElementById('GameForm');
    let step = 'play', lastFocus = null, timer = 0;

    /* ---------- open, close, steps ---------- */
    function show(name){
      step = name;
      steps.forEach(s => { s.hidden = s.dataset.step !== name; });
      if (!g.hidden && name !== 'play'){
        const h = g.querySelector(`[data-step="${name}"] h2`);
        if (h) h.focus();
      }
    }
    function open(at){
      if (!g.hidden) return;
      lastFocus = document.activeElement;
      show(at || 'play');
      g.hidden = false;
      html.classList.add('game-open');
      requestAnimationFrame(() => requestAnimationFrame(() => g.classList.add('on')));
      setTimeout(() => {
        const f = at && at !== 'play' ? g.querySelector(`[data-step="${at}"] h2`) : cards.find(c => !c.classList.contains('up'));
        (f || box).focus();
      }, 80);
    }
    function close(remember){
      if (g.hidden) return;
      if (remember !== false && !preview) store.set(step === 'code' ? 'done' : 'closed');
      g.classList.remove('on');
      html.classList.remove('game-open');
      setTimeout(() => { g.hidden = true; }, reduce ? 0 : 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    g.querySelectorAll('[data-game-close]').forEach(b => b.addEventListener('click', () => close()));
    g.addEventListener('keydown', e => {
      if (e.key === 'Escape'){ e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      // keep focus inside the dialog
      const f = [...box.querySelectorAll('button, a[href], input:not([type="hidden"])')].filter(el => el.offsetParent !== null && !el.disabled);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    });

    /* ---------- the game ---------- */
    const PLAN = ['hit', 'miss', 'hit', 'hit'];   // three of a kind on the fourth flip
    let turn = 0, hits = 0, over = false;
    function flip(c, kind){
      c.querySelector('.gcard-front').textContent = kind === 'hit' ? d.offer : '';
      c.classList.add('up', kind);
      c.setAttribute('aria-disabled', 'true');
      c.setAttribute('aria-label', `Card ${c.dataset.n}: ${kind === 'hit' ? d.offer : 'no prize'}`);
    }
    cards.forEach(c => c.addEventListener('click', () => {
      if (over || c.classList.contains('up')) return;
      const kind = PLAN[turn++] || 'hit';
      flip(c, kind);
      if (kind === 'hit'){ hits++; if (dots[hits - 1]) dots[hits - 1].classList.add('on'); }
      if (hits >= 3){ win(); return; }
      status.textContent = kind === 'hit' ? (d.hit || '').replace('[n]', 3 - hits) : d.miss;
    }));
    function win(){
      over = true;
      status.textContent = d.win;
      g.classList.add('won');
      setTimeout(() => cards.filter(c => !c.classList.contains('up')).forEach(c => { flip(c, 'miss'); c.classList.add('rest'); }), reduce ? 0 : 450);
      setTimeout(() => {
        if (d.email === 'true' && form){ show('email'); }
        else { unlock(); show('code'); }
      }, reduce ? 900 : 1700);
    }

    /* ---------- the code: saved for the basket, and set on the session for any checkout path ---------- */
    function unlock(){
      if (!code) return;
      try { sessionStorage.setItem('yCode', code); } catch(e){}
      document.dispatchEvent(new CustomEvent('yancha:code', {detail: code}));
      const root = ((window.Yancha && Yancha.routes && Yancha.routes.root) || '/').replace(/\/$/, '');
      fetch(`${root}/discount/${encodeURIComponent(code)}`, {credentials: 'same-origin', redirect: 'manual'}).catch(() => {});
      if (!preview) store.set('done');
    }
    const copyBtn = g.querySelector('[data-game-copy]');
    if (copyBtn) copyBtn.addEventListener('click', () => {
      const label = copyBtn.textContent;
      const done = () => { copyBtn.textContent = d.copied; setTimeout(() => { copyBtn.textContent = label; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, () => {});
    });
    const shopBtn = g.querySelector('[data-game-shop]');
    // close first; the theme's link handler then scrolls (same page) or moves to the shop page
    if (shopBtn) shopBtn.addEventListener('click', () => close());

    /* ---------- email: shopify customer form, sent in place; falls back to a normal post (e.g. a spam challenge) ---------- */
    if (form) form.addEventListener('submit', e => {
      const email = form.querySelector('input[type="email"]');
      if (!email || !email.checkValidity()) return;
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      btn.setAttribute('aria-busy', 'true');
      if (preview){ unlock(); show('code'); btn.removeAttribute('aria-busy'); return; }
      fetch(form.action, {method: 'POST', body: new FormData(form), credentials: 'same-origin'})
        .then(r => {
          if (!/customer_posted=true/.test(r.url)) throw new Error('fallback');
          unlock(); show('code');
          btn.removeAttribute('aria-busy');
        })
        .catch(() => { flag.set(true); HTMLFormElement.prototype.submit.call(form); });
    });

    /* ---------- when to open ---------- */
    if (preview){
      // theme editor: open while the section is selected, never on its own
      document.addEventListener('shopify:section:select', e => { if (e.target.contains(g)) open(); });
      document.addEventListener('shopify:section:deselect', e => { if (e.target.contains(g)) close(false); });
      return;
    }
    if (flag.get()){
      flag.set(false);
      if (g.querySelector('[data-game-posted]')){ unlock(); open('code'); return; }
      if (g.querySelector('[data-game-error]')){ open('email'); return; }
    }
    const st = store.get();
    if (st && (st.s === 'done' || Date.now() - st.t < (+d.days || 14) * DAY)) return;
    function tryOpen(){
      // wait for the opening reveal, an open basket or an open menu to clear
      if (document.querySelector('.cart-open, .intro.on, .menu ul.open')){ timer = setTimeout(tryOpen, 2500); return; }
      open();
    }
    timer = setTimeout(tryOpen, Math.max(0, +d.delay || 0) * 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
